// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__141C1","label":"LabeledBox_label__2rQiN"};